import React, { useEffect, useState } from 'react';
import { Modal, Button, Spin, Typography, Space, message } from 'antd';
import { useModel } from '@umijs/max';
import { getCallerEnterprises, updateAuthorizationStatus } from '@/services/service';

const { Title, Paragraph } = Typography;

const AuthorizationCheck: React.FC = () => {
  const { initialState } = useModel('@@initialState');
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [authData, setAuthData] = useState<any>(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    checkAuthorization();
  }, [initialState?.currentUser?.enterpriseCode]);

  const checkAuthorization = async () => {
    if (!initialState?.currentUser?.enterpriseCode) {
      return;
    }

    try {
      setLoading(true);
      const response = await getCallerEnterprises({
        createdEnterpriseCode: initialState.currentUser.enterpriseCode,
      });

      console.log('授权检查响应:', response);

      // 处理响应格式
      let dataList = [];
      if (response && response.code === 0 && response.data && Array.isArray(response.data)) {
        dataList = response.data;
      } else if (Array.isArray(response)) {
        dataList = response;
      }

      // 查找状态为 N 的授权记录
      const unauthorizedItem = dataList.find((item: any) => item.authorizationStatus === 'N');

      if (unauthorizedItem) {
        setAuthData(unauthorizedItem);
        setVisible(true);
      }
    } catch (error) {
      console.error('授权检查失败:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAuthorize = async () => {
    if (!authData || !initialState?.currentUser?.enterpriseCode) {
      return;
    }

    try {
      setSubmitting(true);
      const response = await updateAuthorizationStatus({
        callerEnterpriseCode: authData.callerEnterpriseCode,
        createdEnterpriseCode: initialState.currentUser.enterpriseCode,
        status: 'Y',
      });

      console.log('授权更新响应:', response);

      if (
        response === true ||
        (response && response.code === 0) ||
        (response && response.success === true) ||
        (response && response.data === true)
      ) {
        message.success('授权成功');
        setVisible(false);
        setAuthData(null);
      } else {
        message.error(response?.msg || '授权失败');
      }
    } catch (error) {
      console.error('授权失败:', error);
      message.error('授权失败，请重试');
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    setVisible(false);
  };

  if (loading) {
    return null;
  }

  return (
    <Modal
      title="授权申请"
      open={visible}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          拒绝
        </Button>,
        <Button key="authorize" type="primary" loading={submitting} onClick={handleAuthorize}>
          允许授权
        </Button>,
      ]}
      width={600}
      maskClosable={false}
    >
      <Space direction="vertical" style={{ width: '100%' }} size="large">
        <div>
          <Title level={4}>授权文档预览</Title>
          <Paragraph>
            企业 <strong>{authData?.callerEnterpriseCode}</strong> 请求访问您的企业数据。
          </Paragraph>
          <Paragraph>
            授权后，该企业将能够访问您的外协相关进度数据。请仔细确认后再进行授权操作。
          </Paragraph>
        </div>

        {authData && (
          <div style={{ background: '#f5f5f5', padding: '16px', borderRadius: '4px' }}>
            <Paragraph>
              <strong>调用方企业代码：</strong>{authData.callerEnterpriseCode}
            </Paragraph>
            <Paragraph>
              <strong>创建时间：</strong>{authData.createTime}
            </Paragraph>
            {authData.extraContent && (
              <Paragraph>
                <strong>备注：</strong>{authData.extraContent}
              </Paragraph>
            )}
          </div>
        )}
      </Space>
    </Modal>
  );
};

export default AuthorizationCheck;
